const userNav = document.querySelector('.user-nav');
const moreButton = document.querySelector('.user-nav__ul__li__item[type="button"]');
const moreNav = document.querySelector('.user-nav__ul__ul');
const moreNavContainerExpanded = 'user-nav__ul__li--expanded';

if (userNav) {
  const toggleButton = document.querySelector('.user-nav__toggle');
  const userNavExpanded = 'user-nav--expanded';

  // Toggle user-nav on mobile
  const toggleUserNav = (event) => {
    if (userNav.classList.contains(userNavExpanded)) {
      userNav.classList.remove(userNavExpanded);
      toggleButton.setAttribute('aria-expanded', false);
    } else {
      userNav.classList.add(userNavExpanded);
      toggleButton.setAttribute('aria-expanded', true);
    }
    event.stopPropagation();
    return false;
  };
  toggleButton.addEventListener('click', toggleUserNav);

  if (moreButton) {
    // Toggle more-nav
    const moreNavContainer = moreButton.closest('.user-nav__ul__li');
    const toggleMoreNav = (event) => {
      if (moreNavContainer.classList.contains(moreNavContainerExpanded)) {
        moreNavContainer.classList.remove(moreNavContainerExpanded);
      } else {
        moreNavContainer.classList.add(moreNavContainerExpanded);
      }
      event.stopPropagation();
      return false;
    };
    moreButton.addEventListener('click', toggleMoreNav);

    // Close more-nav on click outside
    const clickOutsideMoreNav = (event) => {
      const isClickInside = moreNav.contains(event.target);
      if (!isClickInside) {
        moreNavContainer.classList.remove(moreNavContainerExpanded);
      }
    };
    document.addEventListener('click', clickOutsideMoreNav);
  }
}
